module.exports = __webpack_public_path__ + "assets/img/titians-ludimos.532466ae.jpg";